export class TcListPageModel {
  after: number | string;
  first: number;
}
